import { SlidersHorizontal } from 'lucide-react';
import { TopbarSearch } from '@/components/ui/TopbarSearch';
import type { PermissionFilters, PermissionModule } from '../types/permissionsList.types';

interface PermissionsToolbarProps {
  filters: PermissionFilters;
  modules: PermissionModule[];
  onFiltersChange: (filters: PermissionFilters) => void;
}

export function PermissionsToolbar({ filters, modules, onFiltersChange }: PermissionsToolbarProps) {
  return (
    <div className="rounded-md border border-slate-100 bg-white p-3 shadow-sm flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
      <div className="flex flex-row items-center gap-2 flex-1">
        <div className="flex-1 min-w-0">
          <TopbarSearch
            value={filters.query}
            onChange={(query) => onFiltersChange({ ...filters, query })}
            placeholder="Tìm module, tài nguyên hoặc quyền"
          />
        </div>
      </div>
      <div className="flex flex-row items-center gap-2 overflow-x-auto">
        <select
          value={filters.module}
          onChange={(event) => onFiltersChange({ ...filters, module: event.target.value })}
          className="h-10 shrink-0 rounded-md border border-slate-200 bg-white px-2 text-xs text-slate-700 outline-none w-[130px] sm:w-[160px]"
        >
          <option value="all">Tất cả module</option>
          {modules.map((module) => (
            <option key={module.code} value={module.code}>{module.name}</option>
          ))}
        </select>
        <select
          value={filters.risk}
          onChange={(event) => onFiltersChange({ ...filters, risk: event.target.value as PermissionFilters['risk'] })}
          className="h-10 shrink-0 rounded-md border border-slate-200 bg-white px-2 text-xs text-slate-700 outline-none w-[110px] sm:w-[130px]"
        >
          <option value="all">Tất cả rủi ro</option>
          <option value="Thấp">Thấp</option>
          <option value="Vừa">Vừa</option>
          <option value="Cao">Cao</option>
          <option value="Rất cao">Rất cao</option>
        </select>
      </div>
    </div>
  );
}
